module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/page09_fig01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "imgcaption"
  }, [_vm._v("A classic Charlotte street scene from its trolley era. Charlotte was built on business and liked new technology, such as the electric streetcar. "), _c('i', [_vm._v("Courtesy of the Robinson-Spangler Carolina Room of the Public Library of Charlotte and Mecklenburg County")]), _vm._v(".")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-157dcf28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/frontmatter.vue
// module id = 72
// module chunks = 0